import React from "react";
import { loadModules } from "esri-loader";

//https://www.esri.com/arcgis-blog/products/js-api-arcgis/mapping/dot-density-for-the-web/
//https://ekenes.github.io/conferences/ds-2019/plenary/dot-density-legend/index.html
//https://developers.arcgis.com/javascript/latest/sample-code/sandbox/index.html?sample=visualization-dot-density
//https://github.com/ekenes/conferences/blob/master/ds-2019/plenary/dot-density-legend/index.html

export default class DotDensityTestMapView extends React.Component {
  constructor(props) {
    super(props);
    this.mapRef = React.createRef();
  }

  componentDidMount() {
    // lazy load the required ArcGIS API for JavaScript modules and CSS
    loadModules(
      [
        "esri/Map",
        "esri/WebMap",
        "esri/views/MapView",
        "esri/Basemap",
        "esri/layers/FeatureLayer",
        "esri/renderers/DotDensityRenderer",
        "esri/widgets/Legend",
        "esri/widgets/Bookmarks",
        "esri/webmap/Bookmark",
        "esri/widgets/Expand",
        "esri/widgets/LayerList",
        "esri/widgets/Slider",
        "esri/geometry/Extent",
      ],
      { css: true }
    ).then(
      ([
        ArcGISMap,
        WebMap,
        MapView,
        Basemap,
        FeatureLayer,
        DotDensityRenderer,
        Legend,
        Bookmarks,
        Bookmark,
        Expand,
        LayerList,
        Slider,
        Extent,
      ]) => {
        // const map = new ArcGISMap({
        //     basemap: 'topo-vector'
        // });

        const map = new WebMap({
          portalItem: {
            id: "da83595b291349b79c7e56e5fabc5fde",
          },
          // basemap: Basemap.fromId("streets-night-vector")
          center: [-122.057281, 38.250313],
          zoom: 10,
        });

        map.center = [-122.057281, 38.250313];

        this.view = new MapView({
          container: this.mapRef.current,
          map: map,
          center: [-122.057281, 38.250313],
          zoom: 8,
          highlightOptions: {
            fillOpacity: 0,
            color: [50, 50, 50],
          },
          popup: {
            dockEnabled: true,
            dockOptions: {
              position: "top-right",
              breakpoint: false,
            },
          },
          constraints: {
            maxScale: 35000,
          },
        });

        const dotDensityRenderer = new DotDensityRenderer({
          dotValue: 100,
          // referenceDotValue: 4800,
          outline: null, // avoid the default outline
          referenceScale: 577790,
          legendOptions: {
            // legend displays 1 dot = 4800 people
            unit: "people",
          },
          attributes: [
            {
              field: "B03002_001E", // field name for population
              color: "#e8ca0d",
              label: "Areas where people live", // label in legend
            },
          ],
        });

        dotDensityRenderer.attributes = [
          {
            field: "B03002_003E",
            color: "#f23c3f",
            label: "White (non-Hispanic)",
          },
          {
            field: "B03002_012E",
            color: "#e8ca0d",
            label: "Hispanic",
          },
          {
            field: "B03002_004E",
            color: "#00b6f1",
            label: "Black or African American",
          },
          {
            field: "B03002_006E",
            color: "#32ef94",
            label: "Asian",
          },
          {
            field: "B03002_005E",
            color: "#ff7fe9",
            label: "American Indian/Alaskan Native",
          },
          {
            field: "B03002_007E",
            color: "#e2c4a5",
            label: "Pacific Islander/Hawaiian Native",
          },
          {
            field: "B03002_008E",
            color: "#ff6a00",
            label: "Other race",
          },
          {
            field: "B03002_009E",
            color: "#96f7ef",
            label: "Two or more races",
          },
        ];

        const url =
          "https://services.arcgis.com/P3ePLMYs2RVChkJx/ArcGIS/rest/services/ACS_Population_by_Race_and_Hispanic_Origin_Boundaries/FeatureServer/2/";
        var popDensityLayer = new FeatureLayer({
          url: url,
          definitionExpression: "State='California'",
          //outFields: ["*"],
          minScale: 20000000,
          maxScale: 35000,
          title: "Current Population Estimates (ACS)",
          popupTemplate: {
            title: "{County}, {State}",
            content: [
              {
                type: "fields",
                fieldInfos: [
                  {
                    fieldName: "B03002_003E",
                    label: "White (non-Hispanic)",
                    format: {
                      digitSeparator: true,
                      places: 0,
                    },
                  },
                  {
                    fieldName: "B03002_012E",
                    label: "Hispanic",
                    format: {
                      digitSeparator: true,
                      places: 0,
                    },
                  },
                  {
                    fieldName: "B03002_004E",
                    label: "Black or African American",
                    format: {
                      digitSeparator: true,
                      places: 0,
                    },
                  },
                  {
                    fieldName: "B03002_006E",
                    label: "Asian",
                    format: {
                      digitSeparator: true,
                      places: 0,
                    },
                  },
                  {
                    fieldName: "B03002_005E",
                    label: "American Indian/Alaskan Native",
                    format: {
                      digitSeparator: true,
                      places: 0,
                    },
                  },
                  {
                    fieldName: "B03002_007E",
                    label: "Pacific Islander/Hawaiian Native",
                    format: {
                      digitSeparator: true,
                      places: 0,
                    },
                  },
                  {
                    fieldName: "B03002_008E",
                    label: "Other race",
                    format: {
                      digitSeparator: true,
                      places: 0,
                    },
                  },
                  {
                    fieldName: "B03002_009E",
                    label: "Two or more races",
                    format: {
                      digitSeparator: true,
                      places: 0,
                    },
                  },
                ],
              },
            ],
          },
          renderer: dotDensityRenderer,
        });

        const statesRenderer = {
          type: "simple", // autocasts as new SimpleRenderer()
          symbol: {
            type: "simple-fill", // autocasts as new SimpleFillSymbol()
            color: [0, 0, 0, 0],
            outline: {
              color: [50, 50, 50, 0.7],
              width: 0.5,
            },
          },
        };

        const statesLayer = new FeatureLayer({
          url:
            "https://sampleserver6.arcgisonline.com/arcgis/rest/services/Census/MapServer/3",
          renderer: statesRenderer,
          definitionExpression: "STATE_NAME = 'California'",
        });
        map.add(statesLayer);
        map.add(popDensityLayer);
        // this.view.ui.add(
        //     [
        //         new Expand({
        //             view: this.view,
        //             content: new Legend({ view: this.view }),
        //             group: "top-left",
        //             expanded: true
        //         }),
        //         new Expand({
        //             view: this.view,
        //             content: new Bookmarks({ view: this.view }),
        //             group: "top-left"
        //         })
        //     ],
        //     "top-left"
        // )
        // var legendContainer = document.getElementById("legendDiv");
        var legend = new Legend({
          view: this.view,
          container: "legendDiv",
        });
        var legendContainer = document.getElementById("legendDiv");

        this.view.ui.add(
          [
            // new Expand({
            //     view: this.view,
            //     content: new Legend({ view: this.view }),
            //     group: "top-left",
            //     expanded: true
            // }),
            new Expand({
              view: this.view,
              content: document.getElementById("controlDiv"),
              group: "top-left",
              expanded: true,
              expandIconClass: "esri-icon-layer-list",
            }),
            new Expand({
              view: this.view,
              expandIconClass: "esri-icon-filter",
              content: document.getElementById("sliderDiv"),
              group: "top-left",
            }),
          ],
          "top-left"
        );

        var bookmarks = new Bookmarks({
          view: this.view,
          editingEnabled: true,
          bookmarks: [],
        });

        var sacramentoBookmark = new Bookmark({
          name: "Sacramento",
          extent: new Extent({
            xmin: -121.381607,
            xmax: -121.592883,
            ymin: 38.538727,
            ymax: 38.619837,
          }),
        });

        var sanFranciscoBookmark = new Bookmark({
          name: "San Francisco",
          extent: new Extent({
            xmin: -122.038817,
            xmax: -122.752494,
            ymin: 37.615527,
            ymax: 37.880657,
          }),
        });

        var losAngelesBookmark = new Bookmark({
          name: "Los Angeles",
          extent: new Extent({
            xmin: -117.268015,
            xmax: -118.80107,
            ymin: 33.702436,
            ymax: 34.24332,
          }),
        });

        bookmarks.bookmarks.push(sacramentoBookmark);
        bookmarks.bookmarks.push(sanFranciscoBookmark);
        bookmarks.bookmarks.push(losAngelesBookmark);

        this.view.ui.add(
          new Expand({
            view: this.view,
            content: bookmarks,
            group: "bottom-right",
            expanded: false,
          }),
          "bottom-right"
        );

        legendContainer.addEventListener("mousemove", legendEventListener);
        legendContainer.addEventListener("click", legendEventListener);

        let mousemoveEnabled = true;

        //enables exploration on mouse move
        const resetButton = document.getElementById("reset-button");
        resetButton.addEventListener("click", () => {
          mousemoveEnabled = true;
          popDensityLayer.renderer = dotDensityRenderer;
          legendContainer.addEventListener("mousemove", legendEventListener);
        });

        function legendEventListener(event) {
          const selectedText = event.target.alt || event.target.innerText;
          const legendInfos = legend.activeLayerInfos.getItemAt(0)
            .legendElements[0].infos;
          const matchFound =
            legendInfos.filter((info) => info.label === selectedText).length >
            0;
          if (matchFound) {
            showSelectedField(selectedText);
            if (event.type === "click") {
              mousemoveEnabled = false;
              legendContainer.removeEventListener(
                "mousemove",
                legendEventListener
              );
            }
          } else {
            popDensityLayer.renderer = dotDensityRenderer;
          }
        }

        function showSelectedField(label) {
          const oldRenderer = popDensityLayer.renderer;
          const newRenderer = oldRenderer.clone();
          const attributes = newRenderer.attributes.map((attribute) => {
            attribute.color.a = attribute.label === label ? 1 : 0.2;
            return attribute;
          });
          newRenderer.attributes = attributes;
          popDensityLayer.renderer = newRenderer;
        }

        const dotValueSlider = document.getElementById("dotValueInput");
        const dotValueDisplay = document.getElementById("dotValueDisplay");
        dotValueSlider.addEventListener("input", () => {
          const oldRenderer = popDensityLayer.renderer;
          const newRenderer = oldRenderer.clone();
          dotValueDisplay.innerText = dotValueSlider.value;
          const dotValue = parseInt(dotValueSlider.value);
          newRenderer.referenceDotValue = dotValue;
          popDensityLayer.renderer = newRenderer;
        });
      }
    );
  }

  componentWillUnmount() {
    if (this.view) {
      // destroy the map view
      this.view.container = null;
    }
  }

  render() {
    return (
      <div>
        <div id="controlDiv" className="esri-widget">
          <div id="legendDiv"></div>
          <div id="buttonDiv">
            <div id="instructions">
              Hover over category to emphasize it. Click category to freeze
              selection.
            </div>
            <button id="reset-button" className="esri-widget">
              Reset
            </button>
          </div>
        </div>
        <div id="sliderDiv" className="esri-widget">
          Dot Value: <span id="dotValueDisplay">100</span>
          <input
            type="range"
            className="esri-widget"
            id="dotValueInput"
            min="1"
            max="200"
            step="1"
            value="50"
          />
        </div>
        <div className="webmap webmap-full" ref={this.mapRef} />
      </div>
    );
  }
}
